import { render, staticRenderFns } from "./RegisterationDone.vue?vue&type=template&id=28808704&scoped=true&"
import script from "./RegisterationDone.vue?vue&type=script&lang=js&"
export * from "./RegisterationDone.vue?vue&type=script&lang=js&"
import style0 from "./RegisterationDone.vue?vue&type=style&index=0&id=28808704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28808704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VLayout})
